import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'Is this a physical product or a digital download?',
  a: 'This is a 100% digital product delivered in high-quality PDF format with editable resources. You can access it immediately from your computer, tablet, or smartphone after purchase.'
}, {
  q: 'Is it suitable for newly qualified nutrition professionals?',
  a: 'Absolutely. The system is designed for both newly qualified Nutritionists and experienced professionals who want to save time, standardize their workflow, and deliver a more professional consultation experience.'
}, {
  q: 'Can I use it in private practice and online consultations?',
  a: 'Yes. All assessment tools, nutrition planning templates, educational resources, and tracking systems are fully adaptable to private practices, wellness clinics, hospitals, and online nutrition consultations.'
}, {
  q: 'Can it be used with different types of clients?',
  a: 'Yes. The system is designed to support nutrition professionals working with a wide variety of clients and nutritional goals by providing flexible templates, educational materials, planning systems, and progress tracking tools that can easily be adapted to individual needs.'
}, {
  q: 'How quickly will I notice the benefits?',
  a: 'Most nutrition professionals report feeling significantly more organized, confident, and prepared from the very first day they begin using the system in their daily consultations.'
}, {
  q: 'Are the templates editable and can I add my own branding?',
  a: 'Yes. The forms, meal planning layouts, and educational handouts are editable so you can personalize them with your own logo, colors, and practice details to deliver a fully branded, premium client experience.'
}, {
  q: 'Is this a one-time payment or a subscription?',
  a: 'It is a one-time payment. You pay $27 once and get lifetime access to the complete Nutritionist Pro™ system and all 5 premium bonuses. There are no hidden fees or recurring charges.'
}, {
  q: 'Do I get access to the bonuses immediately?',
  a: 'Yes. All 5 premium bonuses are included with your purchase today and are delivered instantly by email alongside the complete 6-in-1 system.'
}, {
  q: 'What is the refund process if I am not satisfied?',
  a: 'Simply contact us within 7 days of your purchase and we will refund 100% of your money — no risk and no questions asked. Your investment is completely protected.'
}, {
  q: 'Do I need any special software to use the resources?',
  a: 'No special software is required. All resources open in standard PDF format and the editable files work with common tools you already use, so you can start using them with your clients right away.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-8 px-4 bg-brand-cream" data-id="element-37">
      <div className="max-w-3xl mx-auto" data-id="element-38">
        <div className="text-center mb-6" data-id="element-39">
          <h2 className="text-2xl sm:text-3xl font-serif font-extrabold text-brand-graphite mb-1 uppercase" data-id="element-40">
            FREQUENTLY ASKED QUESTIONS
          </h2>
        </div>

        <div className="space-y-2" data-id="element-41">
          {faqs.map((faq, i) => <div key={i} className="bg-white border-2 border-brand-gold/30 rounded-lg overflow-hidden shadow-sm" data-id="element-42">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-4 py-3 text-left flex justify-between items-center hover:bg-brand-cream/50 transition-colors gap-3" data-id="element-43">
                <span className="font-bold text-brand-graphite text-sm sm:text-base leading-snug" data-id="element-44">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-petrol transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-45" />
              </button>

              {openIndex === i && <div className="px-4 pb-3 pt-0 text-brand-graphite/80 font-medium text-sm leading-snug" data-id="element-46">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}